import PublicFooter from './PublicFooter'

export default PublicFooter
